export const QUERY = `
query AIFirstCreateFields($project: JiraProjectInput, $issueType: JiraIssueTypeInput, $issueTypes: String, $requestTypes: String, $withNumberFormat: Boolean!) {
  jiraIssueCreateFields(
    fieldsFilter: USER_CONFIGURED_FIELDS
    project: $project
    issueType: $issueType
  ) {
    ... on JiraIssueCreateFields {
      fields {
        nodes {
          ...BaseFieldFragment
          ...ProjectFieldFragmentWithoutClassification
          ...IssueTypeFieldSearchFragment
          ...RequestTypeFieldSearchFragment
          ...TextFieldFragment
          ...RichTextFieldFragment
          ...ComponentsFieldFragment
          ...VersionFieldFragment
          ...MultiVersionFieldFragment
          ...PriorityFieldFragment
          ...SprintFieldFragment
          ...LabelWithColorFieldFragment
          ...SingleUserPickerFieldFragment
          ...MultiUserPickerFieldFragment
          ...PeopleFieldFragment
          ...SecurityFieldFragment
          ...IssueRestrictionFieldFragment
          ...ColorFieldFragment
          ...ResolutionFieldFragment
          ...SingleSelectFieldFragment
          ...MultiSelectFieldFragment
          ...NumberFieldFragment
          ...UrlFieldFragment
          ...EpicLinkFieldFragment
          ...DatePickerFieldFragment
          ...DateTimePickerFieldFragment
          ...CascadingSelectFieldFragment
          ...AttachmentsFieldFragment
          ...CheckboxFieldFragment
          ...SingleGroupPickerFieldFragment
          ...MultiGroupPickerFieldFragment
          ...TeamFieldFragment
          ...AtlassianTeamFieldFragment
          ...RadioSelectFieldFragment
          ...AffectedServicesFieldFragment
          ...CMDBFieldFragment
          ...OrganizationsFieldFragment
          ...ConnectTextFieldFragment
          ...ConnectNumberFieldFragment
          ...ConnectSingleSelectFieldFragment
          ...ConnectMultiSelectFieldFragment
          ...ConnectRichTextFieldFragment
          ...AssetFieldFragment
          ...ForgeStringFieldFragment
          ...ForgeNumberFieldFragment
          ...ForgeSingleUserPickerFieldFragment
          ...ForgeMultiUserPickerFieldFragment
          ...ForgeGroupPickerFieldFragment
          ...ForgeMultiGroupPickerFieldFragment
          ...ForgeStringsFieldFragment
          ...ForgeObjectFieldFragment
          ...ForgeDateTimePickerFieldFragment
          ...TimeTrackingFieldFragment
          ...WorkLogFieldFragment
          ...JsmMultiUserPickerFieldFragment
          ...JsmPeopleFieldFragment
          ...ParentLinkFieldFragment
          ...DataClassificationFieldFragmentWithOrgDefault
          ...ParentFieldFragment
          ...StatusFieldFragment
          __typename
        }
        __typename
      }
      errors {
        identifier
        extensions {
          ... on JiraIssueFieldUnsupportedErrorExtension {
            fieldName
            fieldType
            isRequiredField
            __typename
          }
          ... on JiraIssueFieldValueValidationErrorExtension {
            errorType
            message
            __typename
          }
          __typename
        }
        __typename
      }
      __typename
    }
    ... on QueryError {
      message
      __typename
    }
    __typename
  }
}

fragment BaseFieldFragment on JiraIssueField {
  fieldId
  name
  type
  description
  ... on JiraIssueFieldConfiguration {
    fieldConfig {
      isRequired
      isEditable
      nonEditableReason {
        message
        __typename
      }
      __typename
    }
    __typename
  }
  __typename
}

fragment ProjectFieldFragmentWithoutClassification on JiraProjectField {
  project {
    ...Project
    __typename
  }
  searchUrl
  __typename
}

fragment Project on JiraProject {
  id: projectId
  name
  avatar {
    large
    __typename
  }
  projectType
  simplified
  key
  __typename
}

fragment IssueTypeFieldSearchFragment on JiraIssueTypeField {
  issueType {
    ...IssueType
    __typename
  }
  issueTypes(searchBy: $issueTypes) {
    nodes {
      ...IssueType
      __typename
    }
    __typename
  }
  __typename
}

fragment IssueType on JiraIssueType {
  id: issueTypeId
  name
  avatar {
    large
    __typename
  }
  __typename
}

fragment RequestTypeFieldSearchFragment on JsmRequestTypeField {
  requestType {
    ...RequestType
    __typename
  }
  requestTypes(searchBy: $requestTypes) {
    nodes {
      ...RequestType
      __typename
    }
    __typename
  }
  __typename
}

fragment RequestType on JsmRequestType {
  requestTypeId
  name
  description
  helpText
  key
  issueType {
    issueTypeId
    __typename
  }
  avatar {
    large
    __typename
  }
  practices {
    key
    __typename
  }
  __typename
}

fragment TextFieldFragment on JiraSingleLineTextField {
  text
  __typename
}

fragment RichTextFieldFragment on JiraRichTextField {
  richText {
    plainText
    adfValue {
      json
      __typename
    }
    __typename
  }
  renderer
  mediaContext {
    ...JiraMediaContextFragment
    __typename
  }
  ...JiraAdminRichTextFieldConfigFragment
  __typename
}

fragment JiraMediaContextFragment on JiraMediaContext {
  uploadToken {
    ... on JiraMediaUploadToken {
      endpointUrl
      clientId
      targetCollection
      token
      tokenDurationInMin
      __typename
    }
    ... on QueryError {
      message
      __typename
    }
    __typename
  }
  __typename
}

fragment JiraAdminRichTextFieldConfigFragment on JiraRichTextField {
  adminRichTextConfig {
    aiEnabledByProject
    __typename
  }
  __typename
}

fragment ComponentsFieldFragment on JiraComponentsField {
  selectedComponents {
    ...Component
    __typename
  }
  components {
    nodes {
      ...Component
      __typename
    }
    __typename
  }
  __typename
}

fragment Component on JiraComponent {
  id: componentId
  name
  __typename
}

fragment VersionFieldFragment on JiraSingleVersionPickerField {
  version {
    ...Version
    __typename
  }
  versions {
    nodes {
      ...Version
      __typename
    }
    __typename
  }
  __typename
}

fragment Version on JiraVersion {
  id: versionId
  name
  status
  __typename
}

fragment MultiVersionFieldFragment on JiraMultipleVersionPickerField {
  selectedVersions {
    ...Version
    __typename
  }
  versions {
    nodes {
      ...Version
      __typename
    }
    __typename
  }
  __typename
}

fragment PriorityFieldFragment on JiraPriorityField {
  priority {
    ...Priority
    __typename
  }
  priorities {
    nodes {
      ...Priority
      __typename
    }
    __typename
  }
  __typename
}

fragment Priority on JiraPriority {
  name
  id: priorityId
  iconUrl
  __typename
}

fragment SprintFieldFragment on JiraSprintField {
  selectedSprints {
    ...Sprint
    __typename
  }
  searchUrl
  __typename
}

fragment Sprint on JiraSprint {
  sprintId
  name
  state
  __typename
}

fragment LabelWithColorFieldFragment on JiraLabelsField {
  selectedLabels {
    ...LabelWithColor
    __typename
  }
  searchUrl
  __typename
}

fragment LabelWithColor on JiraLabel {
  id: labelId
  name
  color {
    colorKey
    __typename
  }
  __typename
}

fragment SingleUserPickerFieldFragment on JiraSingleSelectUserPickerField {
  user {
    ...UserFragment
    __typename
  }
  searchUrl
  __typename
}

fragment UserFragment on User {
  accountId
  name
  picture
  __typename
}

fragment MultiUserPickerFieldFragment on JiraMultipleSelectUserPickerField {
  selectedUsers {
    ...UserFragment
    __typename
  }
  searchUrl
  __typename
}

fragment SecurityFieldFragment on JiraSecurityLevelField {
  securityLevel {
    ...SecurityLevel
    __typename
  }
  securityLevels {
    nodes {
      ...SecurityLevel
      __typename
    }
    __typename
  }
  __typename
}

fragment SecurityLevel on JiraSecurityLevel {
  id: securityId
  name
  description
  __typename
}

fragment IssueRestrictionFieldFragment on JiraIssueRestrictionField {
  selectedRoles {
    ...UserRoles
    __typename
  }
  __typename
}

fragment UserRoles on JiraRole {
  roleId
  __typename
}

fragment ColorFieldFragment on JiraColorField {
  color {
    colorKey
    __typename
  }
  __typename
}

fragment ResolutionFieldFragment on JiraResolutionField {
  resolution {
    ...Resolution
    __typename
  }
  resolutions {
    nodes {
      ...Resolution
      __typename
    }
    __typename
  }
  __typename
}

fragment Resolution on JiraResolution {
  name
  id: resolutionId
  __typename
}

fragment SingleSelectFieldFragment on JiraSingleSelectField {
  fieldOption {
    ...Option
    __typename
  }
  fieldOptions {
    nodes {
      ...Option
      __typename
    }
    __typename
  }
  __typename
}

fragment Option on JiraOption {
  id: optionId
  value
  __typename
}

fragment MultiSelectFieldFragment on JiraMultipleSelectField {
  selectedFieldOptions {
    ...Option
    __typename
  }
  fieldOptions {
    nodes {
      ...Option
      __typename
    }
    __typename
  }
  searchUrl
  __typename
}

fragment NumberFieldFragment on JiraNumberField {
  number
  formatConfig @include(if: $withNumberFormat) {
    formatStyle
    formatUnit
    formatDecimals
    __typename
  }
  __typename
}

fragment UrlFieldFragment on JiraUrlField {
  url
  __typename
}

fragment EpicLinkFieldFragment on JiraEpicLinkField {
  epic {
    ...Epic
    __typename
  }
  searchUrl
  __typename
}

fragment Epic on JiraEpic {
  name
  key
  summary
  __typename
}

fragment DatePickerFieldFragment on JiraDatePickerField {
  date
  __typename
}

fragment DateTimePickerFieldFragment on JiraDateTimePickerField {
  dateTime
  __typename
}

fragment CascadingSelectFieldFragment on JiraCascadingSelectField {
  cascadingOption {
    parentOptionValue {
      ...Option
      __typename
    }
    childOptionValue {
      ...Option
      __typename
    }
    __typename
  }
  cascadingOptions {
    nodes {
      parentOptionValue {
        ...Option
        __typename
      }
      childOptionValues {
        ...Option
        __typename
      }
      __typename
    }
    __typename
  }
  __typename
}

fragment AttachmentsFieldFragment on JiraAttachmentsField {
  maxAllowedTotalAttachmentsSize
  mediaContext {
    ...JiraMediaContextFragment
    __typename
  }
  __typename
}

fragment CheckboxFieldFragment on JiraCheckboxesField {
  selectedFieldOptions {
    ...Option
    __typename
  }
  fieldOptions {
    nodes {
      ...Option
      __typename
    }
    __typename
  }
  __typename
}

fragment SingleGroupPickerFieldFragment on JiraSingleGroupPickerField {
  selectedGroup {
    ...Group
    __typename
  }
  searchUrl
  __typename
}

fragment Group on JiraGroup {
  groupId
  name
  __typename
}

fragment MultiGroupPickerFieldFragment on JiraMultipleGroupPickerField {
  selectedGroups {
    ...Group
    __typename
  }
  searchUrl
  __typename
}

fragment PeopleFieldFragment on JiraPeopleField {
  selectedUsers {
    ...UserFragment
    __typename
  }
  searchUrl
  isMulti
  __typename
}

fragment TeamFieldFragment on JiraTeamField {
  selectedTeam {
    ...Team
    __typename
  }
  searchUrl
  __typename
}

fragment Team on JiraTeam {
  name
  teamId
  __typename
}

fragment AtlassianTeamFieldFragment on JiraAtlassianTeamField {
  JiraAtlassianTeamField: selectedTeam {
    ...AtlassianTeam
    __typename
  }
  searchUrl
  __typename
}

fragment AtlassianTeam on JiraAtlassianTeam {
  name
  teamId
  avatar {
    small
    __typename
  }
  __typename
}

fragment RadioSelectFieldFragment on JiraRadioSelectField {
  selectedOption {
    ...Option
    __typename
  }
  fieldOptions {
    nodes {
      ...Option
      __typename
    }
    __typename
  }
  __typename
}

fragment AffectedServicesFieldFragment on JiraAffectedServicesField {
  selectedAffectedServices {
    ...AffectedService
    __typename
  }
  searchUrl
  __typename
}

fragment AffectedService on JiraAffectedService {
  serviceId
  __typename
}

fragment CMDBFieldFragment on JiraCMDBField {
  searchUrl
  isMulti
  attributesIncludedInAutoCompleteSearch
  selectedCmdbObjects {
    id
    objectId
    workspaceId
    label
    __typename
  }
  __typename
}

fragment OrganizationsFieldFragment on JsmOrganizationField {
  selectedOrganizations {
    ...Organization
    __typename
  }
  searchUrl
  __typename
}

fragment Organization on JsmOrganization {
  organizationId
  organizationName
  domain
  __typename
}

fragment ConnectTextFieldFragment on JiraConnectTextField {
  text
  __typename
}

fragment ConnectNumberFieldFragment on JiraConnectNumberField {
  number
  __typename
}

fragment ConnectSingleSelectFieldFragment on JiraConnectSingleSelectField {
  fieldOption {
    ...Option
    __typename
  }
  fieldOptions {
    nodes {
      ...Option
      __typename
    }
    __typename
  }
  __typename
}

fragment ConnectMultiSelectFieldFragment on JiraConnectMultipleSelectField {
  selectedFieldOptions {
    ...Option
    __typename
  }
  fieldOptions {
    nodes {
      ...Option
      __typename
    }
    __typename
  }
  __typename
}

fragment ConnectRichTextFieldFragment on JiraConnectRichTextField {
  richText {
    plainText
    adfValue {
      json
      __typename
    }
    __typename
  }
  renderer
  mediaContext {
    ...JiraMediaContextFragment
    __typename
  }
  __typename
}

fragment AssetFieldFragment on JiraAssetField {
  selectedAssets {
    ...Asset
    __typename
  }
  searchUrl
  __typename
}

fragment Asset on JiraAsset {
  serializedOrigin
  appKey
  originId
  value
  __typename
}

fragment ForgeStringFieldFragment on JiraForgeStringField {
  text
  __typename
}

fragment ForgeNumberFieldFragment on JiraForgeNumberField {
  number
  __typename
}

fragment ForgeSingleUserPickerFieldFragment on JiraForgeUserField {
  user {
    ...UserFragment
    __typename
  }
  searchUrl
  __typename
}

fragment ForgeMultiUserPickerFieldFragment on JiraForgeUsersField {
  selectedUsers {
    ...UserFragment
    __typename
  }
  searchUrl
  __typename
}

fragment ForgeGroupPickerFieldFragment on JiraForgeGroupField {
  selectedGroup {
    ...Group
    __typename
  }
  searchUrl
  __typename
}

fragment ForgeMultiGroupPickerFieldFragment on JiraForgeGroupsField {
  selectedGroups {
    ...Group
    __typename
  }
  searchUrl
  __typename
}

fragment ForgeStringsFieldFragment on JiraForgeStringsField {
  selectedLabels {
    ...Label
    __typename
  }
  searchUrl
  __typename
}

fragment Label on JiraLabel {
  id: labelId
  name
  __typename
}

fragment ForgeDateTimePickerFieldFragment on JiraForgeDatetimeField {
  dateTime
  __typename
}

fragment ForgeObjectFieldFragment on JiraForgeObjectField {
  object
  __typename
}

fragment TimeTrackingFieldFragment on JiraTimeTrackingField {
  timeTrackingSettings {
    workingDaysPerWeek
    workingHoursPerDay
    defaultFormat
    defaultUnit
    isJiraConfiguredTimeTrackingEnabled
    __typename
  }
  originalEstimate {
    timeInSeconds
    __typename
  }
  __typename
}

fragment WorkLogFieldFragment on JiraWorkLogField {
  timeTrackingSettings {
    workingDaysPerWeek
    workingHoursPerDay
    defaultFormat
    defaultUnit
    isJiraConfiguredTimeTrackingEnabled
    __typename
  }
  mediaContext {
    ...JiraMediaContextFragment
    __typename
  }
  __typename
}

fragment JsmMultiUserPickerFieldFragment on JsmMultipleSelectUserPickerField {
  selectedUsers {
    ...UserFragment
    __typename
  }
  searchUrl
  __typename
}

fragment JsmPeopleFieldFragment on JsmPeopleField {
  selectedUsers {
    ...UserFragment
    __typename
  }
  searchUrl
  isMulti
  __typename
}

fragment ParentLinkFieldFragment on JiraParentIssueField {
  searchUrl
  parentIssue {
    ...Issue
    __typename
  }
  __typename
}

fragment Issue on JiraIssue {
  key
  issueId
  avatar {
    large
    __typename
  }
  __typename
}

fragment ParentFieldFragment on JiraParentIssueField {
  parentIssue {
    ...ParentIssue
    __typename
  }
  __typename
}

fragment ParentIssue on JiraIssue {
  key
  issueId
  avatar {
    large
    __typename
  }
  issueColorField {
    color {
      colorKey
      __typename
    }
    __typename
  }
  fieldsById(ids: ["summary", "issuetype"]) {
    edges {
      node {
        ... on JiraSingleLineTextField {
          text
          __typename
        }
        ... on JiraIssueTypeField {
          issueType {
            name
            avatar {
              xsmall
              __typename
            }
            __typename
          }
          __typename
        }
        __typename
      }
      __typename
    }
    __typename
  }
  __typename
}

fragment StatusFieldFragment on JiraStatusField {
  name
  description
  aliasFieldId
  __typename
}

fragment DataClassificationFieldFragmentWithOrgDefault on JiraDataClassificationField {
  classificationLevel {
    ...ClassificationLevel
    __typename
  }
  defaultClassificationLevel {
    ...ClassificationLevel
    __typename
  }
  organizationClassificationLevel {
    ...ClassificationLevel
    __typename
  }
  classificationLevels(
    filterByCriteria: {filterByStatus: [PUBLISHED], filterByType: [USER]}
  ) {
    edges {
      node {
        ...ClassificationLevel
        __typename
      }
      __typename
    }
    __typename
  }
  __typename
}

fragment ClassificationLevel on JiraClassificationLevel {
  id
  name
  color {
    colorKey
    __typename
  }
  definition
  status
  __typename
}
`;
